import React from "react";
import TeamCard from "../SubComponents/TeamCard";
import teamImg1 from "../Assets/teamImg1.webp"
import teamImg2 from "../Assets/teamImg2.webp"
import teamImg3 from "../Assets/teamImg3.webp"
import teamImg4 from "../Assets/teamImg4.webp"
// import teamMainImg from "../Assets/teamMainImg.webp"
import teamRoundImg from "../Assets/teamRoundImg.webp"
import teamProfileImg1 from "../Assets/teamProfileIcon.webp"
import teamProfileImg2 from "../Assets/teamProfileIcon2.webp"
import teamProfileImg3 from "../Assets/teamProfileIcon3.webp"
import TeamSliderCard from "../SubComponents/TeamSliderCard";
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination ,Autoplay } from 'swiper/modules';

export default function CommonTeam() {
  return (
    <>
      <div className="teamSection">
        <div className="teamWrapper">
          {/* Team First Block */}
          <div className="topSection">
            <h3>Meet The Team</h3>
            <h1>Our Expert Designers</h1>
          </div>
          <div className="bottomSection">
            <TeamCard title="Rob Hope" designation="CEO & Founder" img={teamImg1} delay={50} />
            <TeamCard title="Patric Green" designation="Chief Designer" img={teamImg2} delay={350} />
            <TeamCard title="Daryl Dixon" designation="Consultant" img={teamImg3} delay={550} />
            <TeamCard title="Mark Parker" designation="Intern" img={teamImg4} delay={750}  />
          </div>

        </div>

                    {/* Team Second Block */}
                    <div className="teamSecondBlock">
                    <div className="roundImg1">
                <img src={teamRoundImg} alt="" />
              </div>
              <div className="roundImg2">
                <img src={teamRoundImg} alt="" />
              </div>
              <div className="roundImg3">
                <img src={teamRoundImg} alt="" />
              </div>
               <div className="teamSecondBlockWrapper">
               <figure className="mainImg">
                {/* <img src={teamMainImg} alt="" /> */}
              </figure>

              <div className="teamSlider">
      <Swiper
                style={{
                  "--swiper-pagination-color": "#fff",
                  "--swiper-pagination-bullet-inactive-color": "rgba(255,255,255,.5)",
                  "--swiper-pagination-bullet-inactive-opacity": "1",
                  "--swiper-pagination-bullet-size": "1.9rem",
                  // "--swiper-pagination-bullet-horizontal-gap": "6px"
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
        pagination={{
          dynamicBullets: true,
          clickable:true,
        }}
        modules={[Pagination , Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide><TeamSliderCard img={teamProfileImg1} name={"Fajar"} designation={"Random Customer"}/></SwiperSlide>
        <SwiperSlide><TeamSliderCard img={teamProfileImg2} name={"Alina"} designation={"Tesla Motors"}/></SwiperSlide>
        <SwiperSlide><TeamSliderCard img={teamProfileImg3} name={"Celina"} designation={"CEO, Alo"}/></SwiperSlide>
      </Swiper>
              </div>
               </div>
            </div>

      </div>
    </>
  );
}
